import { deep_link_base } from "../constants";

/**
 * Builds a shareable profile universal link (https://gigmiapp.com/profile?id=..&user_id=..&type=..).
 * Mirrors the mobile scheme so the same link opens the app when installed or the web fallback otherwise.
 * Replaces the retired Firebase Dynamic Links generator (GIG-25).
 */
export const buildProfileDeepLink = ({ id, user_id, type }) => {
  const params = new URLSearchParams({
    id: id ?? "",
    user_id: user_id ?? "",
    type: type ?? "",
  });
  return `${deep_link_base}/profile?${params.toString()}`;
};
